import React from "react";

import { useAfterHydration } from "../../../common/helpers/afterHydration";
import styled from "styled-components";
import Loader from "../Loader";
import Wrapper from "../Task/Wrapper";

const StyledLoadingFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

// The frame is in the markup the server sends, so the width it scales the loader by has
// to be one the server can name as well - the window's own width is only asked for once
// hydration is over, and React does not patch up an attribute that differs.
const LoadingFrame = () => {
    const afterHydration = useAfterHydration();
    return (
        <div>
            <Wrapper>
                <StyledLoadingFrame
                    style={{
                        transform: `scale(${(1.5 / (afterHydration ? window.innerWidth : 1200)) * 1200})`,
                    }}
                >
                    <Loader />
                </StyledLoadingFrame>
            </Wrapper>
        </div>
    );
};

export default LoadingFrame;
